export default __webpack_public_path__ + "static/media/KE.0ffef367.svg";